import { render, staticRenderFns } from "./ConfirmTask.vue?vue&type=template&id=4bcae322&scoped=true&"
import script from "./ConfirmTask.vue?vue&type=script&lang=js&"
export * from "./ConfirmTask.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmTask.vue?vue&type=style&index=0&id=4bcae322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcae322",
  null
  
)

export default component.exports